import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import axios, { AxiosResponse } from "axios";

export type DriverDataPayload = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    user: string;
    status:string;
};

export type SupplierDriversRequest = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
};

export type SupplierDriversResponse = {
    success: boolean;
    responseBody:any; // Array di autisti
};

export type VehicleDataPayload = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
    licensePlate: string;
    vehicleType: string;
    vehicleSubType: string;
    environmentClass?: string; // Opzionale per i trailer
    fuelType?: string; // Opzionale per i trailer
    firstRegistrationDate?: string; // Opzionale per i trailer
    emissionsData?: number; // Opzionale per i trailer
    emissionsDataUOM:string;
    user: string;
    status: "ACTIVE" | "CANCELLED";
    loadCapacity:number;
    loadCapacityUOM:string;
    VatNumber:string;
    source:string;
 
    
};
export type VehicleDataPayloadUpdate = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
    licensePlate: string;
    vehicleSubType?: string;
    environmentClass?: string;
    fuelType?: string;
    firstRegistrationDate?: string;
    emissionsData?: number; 
    emissionsDataUOM:string;
    user: string;
    loadCapacity:number;
    loadCapacityUOM:string;
    VatNumber: string;
    source:string;
    carrierTMSLocation:string | null;
}

export type InsertVehicleResponse = {
    message: string;
    traceabilitySuccess?: boolean;
    isTraceability?: boolean;
    tripsInfo?: Array<{ tmsObjectNumber: string; tripID: number }>;
    lastTraceabilityCheckDate?: string;
    platform?: string;
};
export type UpdateVehicleResponse = {
    message: string;
    traceabilitySuccess?: boolean;
    isTraceability?: boolean;
    tripsInfo?: Array<{ tmsObjectNumber: string; tripID: number }>;
    lastTraceabilityCheckDate?: string;
    platform?: string;
}

export type DriverVehicleAssociation = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
    vehicleLicensePlate: string;
    phone: string;
    dateFrom: string;
    dateTo?: string | null;
    editUser: string;
    status: "ACTIVE" | "CANCELLED";
};

export type DriverVehicleAssociationResponse = {
    success: boolean;
    successList: {
        id: number;
        licensePlate: string;
        phone: string;
        message: string;
        dateFrom: string;
        dateTo?: string | undefined;
    }[];
    failedList: {
        id: number;
        licensePlate: string;
        phone: string;
        message: string;
        dateFrom: string;
        dateTo?: string | undefined;
    }[];
};

export type UpdateDriverVehicleAssociationPayload = {
    id: number;              // Id dell'associazione da modificare
    newDateFrom: string;     // Nuova data di inizio
    newDateTo?: string;      // Nuova data di fine (opzionale)
    newEditUser: string;     // Nuovo utente che ha creato/modificato
};

export type UpdateDriverVehicleAssociationResponse = {
    message: string;  // Messaggio che descrive l'esito della chiamata
    success: boolean; // Esito della chiamata
};

export type UpdateDriverVehicleAssociationStatusPayload = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
    id: number;
    licensePlate: string;
    status: "ACTIVE" | "CANCELLED";
    editUser: string;
};

export type UpdateDriverVehicleAssociationStatusResponse = {
    message: string;
    success: boolean;
};

export type CheckDriverOnboardingPayload = {
    legacyCodes: {
        legacyCode: string;
        company: string;
    };
    phoneNumber: string;
};

export type CheckDriverOnboardingResponse = {
    result: "OK" | "KO";
    lastAppAccess: string; // Data dell'ultimo accesso
};
export type RequestDriverOnboardingResponse = {
    message: string;
};

export type CountIncompleteVehiclesPayload = {
    LegacyCode: string;
    Company: string;
};

export type CountIncompleteVehiclesResponse = {
    countIncompleteVehicles: number;
};

export const fleetService = {
    putDriver: async (data: DriverDataPayload): Promise<any> => {
        try {
            const response: AxiosResponse<any> = await axios.put(apiUrls.putDriver, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error updating driver:", error);
            throw error;
        }
    },
    getDriversBySupplierCode: async (legacyCode: string, company: string): Promise<IApiServiceResponse> => {
        try {
            const requestBody = {
                    "legacyCode":legacyCode,
                    "company":company
            };
            
            const response: AxiosResponse<IApiServiceResponse> = await axios.post(apiUrls.postDriver, requestBody, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching drivers by supplier code:", error);
            throw error;
        }
    },
    updateDriverById: async (data: any): Promise<IApiServiceResponse> => {
        try {
            const response: AxiosResponse<IApiServiceResponse> = await axios.put(apiUrls.updateDriver, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error updating driver:", error);
            throw error;
        }
    },
    updateDriverStatus: async (legacyCode: string, company: string, phone: string, status: "ACTIVE" | "CANCELLED", editUser:string): Promise<IApiServiceResponse> => {
        try {
            const requestBody = {
                legacyCodes: {
                    legacyCode,
                    company
                },
                phone,
                status,
                editUser
            };
    
            const response: AxiosResponse<IApiServiceResponse> = await axios.put(apiUrls.driverStatus, requestBody, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
    
            return response.data;
        } catch (error) {
            console.error("Errore nell'aggiornamento dello stato dell'autista:", error);
            throw error;
        }
    },
    insertVehicle: async (data: VehicleDataPayload): Promise<InsertVehicleResponse> => {
        try {
            const response: AxiosResponse<InsertVehicleResponse> = await axios.put(apiUrls.insertVehicle, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
            return response.data;
        } catch (error) {
            console.error("Errore nell'inserimento del veicolo:", error);
            throw error;
        }
    },
    updateVehicle: async (data: VehicleDataPayloadUpdate): Promise<UpdateVehicleResponse> => {
        try {
            const response: AxiosResponse<UpdateVehicleResponse> = await axios.put(apiUrls.updateVehicle, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
            return response.data;
        } catch (error) {
            console.error("Errore nell'inserimento del veicolo:", error);
            throw error;
        }
    },
    updateVehicleStatus: async (legacyCode: string, company: string, licensePlate: string, status: "ACTIVE" | "CANCELLED",editUser:string): Promise<any> => {
        try {
            const requestBody = {
                legacyCodes: {
                    legacyCode,
                    company
                },
                licensePlate,
                status,
                editUser
            };
    
            const response: AxiosResponse<IApiServiceResponse> = await axios.put(apiUrls.updateVehicleStatus, requestBody, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
    
            return response.data;
        } catch (error) {
            console.error("Errore nell'aggiornamento dello stato dell'autista:", error);
            throw error;
        }
    },
    getFleetInfoTypes: async (): Promise<any> => {
        try {
            const response: AxiosResponse<any> = await axios.get(apiUrls.vehicleTypes, {
                headers: {
                    'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                }
            });
            return response.data;
        } catch (error) {
            console.error("Errore nel recupero delle informazioni sui tipi di veicolo:", error);
            throw error;
        }
    },
    getFleetInfoBySupplier: async (legacyCode: string, company: string): Promise<any> => {
        try {
            const response: AxiosResponse<any> = await axios.post(apiUrls.fleetVehicle, 
                { legacyCode, company }, 
                {
                    headers: {
                        'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Errore nel recupero delle informazioni della flotta:", error);
            throw error;
        }
    },
    insertDriverVehicleAssociation: async (
        associations: DriverVehicleAssociation[]
    ): Promise<DriverVehicleAssociationResponse> => {
        try {
            const response: AxiosResponse<DriverVehicleAssociationResponse> = await axios.put(
                apiUrls.insertAssociations,
                associations,
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer " + window.sessionStorage.getItem("accessToken")
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error inserting driver-vehicle association:", error);
            throw error;
        }
    },
    updateDriverVehicleAssociation: async (
        payload: UpdateDriverVehicleAssociationPayload
    ): Promise<UpdateDriverVehicleAssociationResponse> => {
        try {
            const response: AxiosResponse<UpdateDriverVehicleAssociationResponse> = await axios.put(
                apiUrls.updateAssociation,  // L'endpoint per aggiornare l'associazione
                payload,  // Passiamo il corpo della richiesta
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer " + window.sessionStorage.getItem("accessToken")
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating driver-vehicle association:", error);
            throw error;
        }
    },
    updateDriverVehicleAssociationStatus: async (
        payload: UpdateDriverVehicleAssociationStatusPayload
    ): Promise<UpdateDriverVehicleAssociationStatusResponse> => {
        try {
            const response: AxiosResponse<UpdateDriverVehicleAssociationStatusResponse> = await axios.put(
                apiUrls.updateAssociationStatus, 
                payload,
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer " + window.sessionStorage.getItem("accessToken"),
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating driver-vehicle association status:", error);
            throw error;
        }
    },
    checkDriverOnboarding: async (data: CheckDriverOnboardingPayload): Promise<CheckDriverOnboardingResponse> => {
        try {
            const response: AxiosResponse<CheckDriverOnboardingResponse> = await axios.put(
                apiUrls.checkDriverOnboarding, 
                data, 
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer " + window.sessionStorage.getItem("accessToken"),
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Errore nel controllo dell'onboarding dell'autista:", error);
            throw error;
        }
    },
    requestDriverOnboarding: async (data: CheckDriverOnboardingPayload): Promise<RequestDriverOnboardingResponse> => {
        try {
            const response: AxiosResponse<RequestDriverOnboardingResponse> = await axios.put(
                apiUrls.requestDriverOnboarding, 
                data, 
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer " + window.sessionStorage.getItem("accessToken"),
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Errore nella richiesta di onboarding dell'autista:", error);
            throw error;
        }
    },
    getFirstDriver: async (legacyCode: string, company: string, licensePlate: string,  date: Date, tripId: string): Promise<any> => {
        try {
            const requestBody = {
                legacyCodes: {
                    legacyCode,
                    company
                },
                licensePlate,
                date,
                tripId
            };
    
            const response: AxiosResponse<any> = await axios.post(apiUrls.getFirstDriver, 
                requestBody,
                {
                    headers: {
                        'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Errore nel recupero delle informazioni della flotta:", error);
            throw error;
        }
    },
    getCountIncompleteVehicles: async (data: CountIncompleteVehiclesPayload): Promise<CountIncompleteVehiclesResponse> => {
        try {
            const response: AxiosResponse<CountIncompleteVehiclesResponse> = await axios.post(
                apiUrls.countIncompleteVehicles,
                data,
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer " + window.sessionStorage.getItem("accessToken"),
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Errore nel recupero del conteggio veicoli incompleti:", error);
            throw error;
        }
    },
};
